import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useDispatch, useSelector } from "react-redux";
import SendReminderView from "../../../../Shared/Component/SendReminder/SendReminderView";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../../../Components/Header/ModalHeader";
import AshaIndividualView from "../AshaIndividualView/AshaIndividualView";
import CustomDataTable from "../../../../Shared/Component/CustomTable/CustomDataTable";
import NoRecordFound from "../../../../Shared/Component/NoRecordFound/NoRecordFound";
import { AshaDeployedByRegionTable } from "../../../../Shared/Constant/TableConstants";
import { SelectButton } from "primereact/selectbutton";
import "./AshaDeployedByRegion.scss";
import { fetchAshaByRegionTable } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import { getAshaByRegionData } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";
import {
  ashaDetailFilterTemplate,
  reminderBodyTemplate,
} from "../../../../Shared/Utils/tableColumns";
import { useTranslation } from "react-i18next";
const AshaDepModal = ({ split, index }) => {
  const ashasData = useSelector(getAshaByRegionData);
  const dispatch = useDispatch();
  const currentYr = new Date().getFullYear();
  const currentDate1 = new Date();
  const currentMonthIndex1 = currentDate1.getMonth();
  const previousMonthIndex1 = (currentMonthIndex1 + 11) % 12;
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const years = [
    2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,2025,2026
  ];
  const { t } = useTranslation("TopAsha");
  const [tabIndex, setTabIndex] = useState(0);
  const [chosenMonth1, setChosenMonth] = useState(months[previousMonthIndex1]);
  const [chosenYr1, setChosenYr] = useState(currentYr);
  const [asName, setAsName] = useState("");
  const [activeAshaList, setActiveAshaList] = useState([]);
  const [inactiveAshaList, setInactiveAshaList] = useState([]);
  const [selectedItems1, setSelectedItems] = useState([]);
  const [isAshaViewVisible1, setIsAshaViewVisible1] = useState(false);
  const [chosenAshaId, setChosenAshaId] = useState("");
  const [chosenIndex, setChosenIndex] = useState(null);
  const [activeStatus, setActiveStatus] = useState(true);
  const dataTribal = [`Tribal`, `Non-Tribal`];
  const initialValue = split === "Non-Tribal" ? dataTribal[1] : dataTribal[0];
  const [valueTribal, setValueTribal] = useState(initialValue);
  const { selectedLanguageId } = useLanguage();
  const handleTabChange = ({ index }) => {
    setTabIndex(index);
    setSelectedItems([]);
    setActiveStatus(index === 0);
  };

  const handleMonthChange = (val) => {
    setChosenMonth(val);
    dispatch(
      fetchAshaByRegionTable(valueTribal, val, chosenYr1, selectedLanguageId)
    );
  };

  const handleYrChange = (val) => {
    setChosenYr(val);
    dispatch(
      fetchAshaByRegionTable(valueTribal, chosenMonth1, val, selectedLanguageId)
    );
  };

  const handleCellClick = (index, ashaid, role, ashaName) => {
    setChosenAshaId(ashaid);
    setIsAshaViewVisible1(true);
    setChosenIndex(index);
    setAsName(ashaName);
  };
  const handleKeyDown = (index, ashaid, role) => (e) => {
    if (e.key === "Enter" || e.key === "Space") {
      handleCellClick(index, ashaid, role);
    }
  };
  const ashaDetailBodyTemplate = ({ ashaid, ashaName, role }) => {
    const handleCellClick = (index, ashaid, role) => {
      setChosenAshaId(String(ashaid));
      setIsAshaViewVisible1(true);
      setChosenIndex(index);
      setAsName(ashaName);
    };
    return (
      <div
        className="text-blue-600 font-normal cursor-pointer"
        onClick={() => handleCellClick(0, ashaid, role)}
        onKeyDown={handleKeyDown(0, ashaid, role)}
        role="button"
        tabIndex={0}
        data-testid="asha-detail-name"
      >
        {ashaName}
      </div>
    );
  };

  const buildSelectedIds = (items) => {
    return items.map((el) => el.ashaid);
  };
  const closeDialog = () => {
    setIsAshaViewVisible1(false);
  };
  function checkAshasDatas(ashasData) {
    return !!ashasData;
  }
  useEffect(() => {
    if (checkAshasDatas(ashasData)) {
      const activeList = ashasData.filter((item) => item.isactive === "Active");
      const inactiveList = ashasData.filter(
        (item) => item.isactive !== "Active"
      );
      setActiveAshaList(activeList);
      setInactiveAshaList(inactiveList);
    }
  }, [ashasData]);
  const filterMethods = {
    ashaName: (options) => ashaDetailFilterTemplate(options, t),
    ashaid: (options) => ashaDetailFilterTemplate(options, t),
    mobileNo: (options) => ashaDetailFilterTemplate(options, t),
    stateName: (options) => ashaDetailFilterTemplate(options, t),
    district: (options) => ashaDetailFilterTemplate(options, t),
    talukas: (options) => ashaDetailFilterTemplate(options, t),
    phcName: (options) => ashaDetailFilterTemplate(options, t),
    subcenterName: (options) => ashaDetailFilterTemplate(options, t),
    villageName: (options) => ashaDetailFilterTemplate(options, t),
    joiningDate: (options) => ashaDetailFilterTemplate(options, t),
    totalActiveCases: (options) => ashaDetailFilterTemplate(options, t),
    totalActivityCount: (options) => ashaDetailFilterTemplate(options, t),
    amount: (options) => ashaDetailFilterTemplate(options, t),
    RemainderCount: (options) => ashaDetailFilterTemplate(options, t),
    inactiveSince: (options) => ashaDetailFilterTemplate(options, t),
  };
  const bodyMethod = {
    ashaName: ashaDetailBodyTemplate,
    // totalActivityCount: ashaActivityBodyTemplate,
    RemainderCount: reminderBodyTemplate,
  };

  const handleTribalValue = (val) => {
    setValueTribal(val);
    dispatch(
      fetchAshaByRegionTable(val, chosenMonth1, chosenYr1, selectedLanguageId)
    );
  };

  useEffect(() => {
    dispatch(
      fetchAshaByRegionTable(
        valueTribal,
        chosenMonth1,
        chosenYr1,
        selectedLanguageId
      )
    );
  }, [valueTribal, chosenMonth1, chosenYr1, selectedLanguageId, dispatch]);
  const dataLength = ashasData && ashasData.length ? ashasData.length : 0;
  const totalAsha = dataLength;
  const activeAshaListLength = activeAshaList ? activeAshaList.length : 0;
  const hasActiveAsha = activeAshaListLength > 0;
  const inactiveAshaListLength = inactiveAshaList ? inactiveAshaList.length : 0;
  const hasInactiveAsha = inactiveAshaListLength > 0;
  return (
    <div className="asha-card">
      <div className="grid align-items-center justify-content-between">
        <div className="sm:col-12 md:col-10 lg:col-10 flex flex-wrap align-items-center">
          <p className="text-xl font-light ml-2">
            {t("ttlAsha")} : {totalAsha}
          </p>
          <div className="ml-2 mr-2">
            <SelectButton
              className="profile-select-btn"
              value={valueTribal}
              onChange={(e) => {
                handleTribalValue(e.value);
              }}
              options={dataTribal.map((tribe) => ({
                label: t(tribe),
                value: tribe,
              }))}
              data-testid="tribal-test"
            />
          </div>
          <div className="ml-2 mr-2">
            <Dropdown
              value={chosenMonth1}
              onChange={(e) => handleMonthChange(e.value)}
              options={months}
              className="cockpit-dropdown"
              data-testid="month-test"
            />
          </div>
          <div className="ml-2 mr-2">
            <Dropdown
              value={chosenYr1}
              onChange={(e) => handleYrChange(e.value)}
              options={years}
              className="cockpit-dropdown"
              data-testid="year-test"
            />
          </div>
        </div>
        <div className="sm:col-12 md:col-2 lg:col-2">
          <SendReminderView
            ashaIds={buildSelectedIds(selectedItems1)}
            isDisabled={selectedItems1.length === 0}
          />
        </div>
      </div>
      <TabView
        activeIndex={tabIndex}
        onTabChange={handleTabChange}
        data-testid="tab-test"
      >
        <TabPanel header={`${t("active")} ${activeAshaList.length}`}>
          {hasActiveAsha ? (
            <div>
              <CustomDataTable
                className="ashaRegion"
                columns={AshaDeployedByRegionTable(t, 0)}
                data={activeAshaList}
                dataKey={(index) => index}
                selectedItems={selectedItems1}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                filterMethods={filterMethods}
                bodyMethods={bodyMethod}
              />
              <p>
                {" "}
                {activeAshaList.length} {t("TotalRecords")}{" "}
              </p>
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
        <TabPanel header={`${t("inactive")} ${inactiveAshaList.length}`}>
          {hasInactiveAsha ? (
            <div>
              <CustomDataTable
                className="ashaRegion"
                columns={AshaDeployedByRegionTable(t, inactiveAshaList.length)}
                data={inactiveAshaList}
                dataKey="id"
                selectedItems={selectedItems1}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                filterMethods={filterMethods}
                bodyMethods={bodyMethod}
              />

              <p>
                {" "}
                {inactiveAshaList.length} {t("TotalRecords")}{" "}
              </p>
            </div>
          ) : (
            <NoRecordFound />
          )}
        </TabPanel>
      </TabView>
      <Dialog
        className="cockpit-dialog"
        visible={isAshaViewVisible1}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsAshaViewVisible1(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={"Back To Table"} />
        }
      >
        <AshaIndividualView
          ashaId={chosenAshaId}
          chosenActiveIndex={chosenIndex}
          name={asName}
          isStatus={activeStatus}
        />
      </Dialog>
    </div>
  );
};

export default AshaDepModal;
